@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.item-display {
  border-radius: 4px;
  background: @item-display--background-color;
  border: 1px solid @item-display--border-color;
  min-height: 80px;
  display: flex;
  overflow: hidden;
  flex: 1;

  &.small {
    min-height: 50px;

    > div {
      display: flex;
    }

    &.no-image {
      .non-image-content {
        max-width: 100%;
      }
    }

    .item-image {
      height: 100%;
      width: 75px;
      min-width: 75px;
    }

    .non-image-content {
      max-width: calc(100% ~'-' 75px);
      justify-content: space-between;
    }

    .text-content {
      margin: 0;
      padding: 0;
      max-width: calc(100% ~'-' 85px);
      flex-direction: column;
    }

    .item-name {
      .truncate();
      max-width: 100%;
      font-size: 13px;
      line-height: 1.2;
    }

    .item-sku {
      font-size: 13px;
    }

    .quantity {
      font-size: 22px;
      line-height: 22px;
    }

    &.no-attributes {
      .non-image-content {
        padding: 0;
      }

      .text-content {
        padding: 8px 10px;
        padding-bottom: 0;
      }

      .quantity-wrapper {
        border-radius: 0;
        padding: 8px 14px;
        height: 100%;
        flex-direction: column;
        align-items: center;

        &.has-four-digits {
          padding: 8px 10px;
          .quantity {
            font-size: 16px;
          }
        }
      }
    }
  }
}

.item-image {
  height: 80px;
  width: 80px;
  min-width: 80px;

  > img,
  > svg {
    height: 100%;
    width: 100%;
  }

  &.empty-image {
    background: @item-display--empty-image--background-color;
    padding: 10px;

    > svg {
      transform: scale(0.7);
      fill: @item-display--empty-image--fill-color;
    }
  }
}

.non-image-content {
  display: flex;
  width: 100%;
  padding: 10px;
}

.text-content {
  width: 100%;
  margin-right: 10px;
}

.item-name {
  font-size: 16px;
  font-weight: @bold;
  text-align: left;
}

.item-sku {
  font-size: 14px;
  font-weight: @bold;
  margin-top: 5px;
}

.item-descriptions {
  color: @item-display--text-color;
  margin-top: 5px;
}

.description {
  font-size: 12px;
  margin-bottom: 5px;

  &:last-child {
    margin-bottom: 0;
  }

  > b {
    margin-right: 5px;
  }
}

.item-price-quantity {
  display: flex;
}

.price-wrapper {
  height: 60px;
  align-self: flex-start;
  margin-right: 10px;
}

.price-content {
  .vertical-align();
  color: @item-display--text-color;
  text-align: center;
}

.total-price {
  font-size: 16px;
  line-height: 20px;
}

.unit-price {
  font-size: 12px;
  white-space: nowrap;
  line-height: 20px;
}

.quantity-wrapper {
  background: @item-display--quantity--background-color;
  text-align: center;
  align-self: flex-start;
  padding: 9px 14px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  &.greater-than-two {
    background: @item-display--quantity-greater-than-two--background-color;
  }

  &.has-four-digits {
    padding: 9px 10px;
    .quantity {
      font-size: 20px;
    }
  }
}

.quantity-title {
  font-size: 11px;
  font-weight: @bold;
  color: @item-display--quantity--text-color;
  text-transform: uppercase;
  letter-spacing: 0.01em;
  line-height: 12px;
  height: 12px;
}

.quantity {
  font-size: 30px;
  line-height: 30px;
  font-weight: @bold;
  color: @item-display--quantity--text-color;
}

.return-reason {
  margin-top: 10px;
  font-size: 12px;
  color: @item-display--text-color;
  margin-bottom: 3px;
}
